
import CbFormTextWithImage from "@/components/layouts/content-blocks/forms/CbFormTextWithImage.vue";
import {PageDetailModeEnum} from "@/models/enum/PageDetailModeEnum";

export default {
  computed: {
    PageDetailModeEnum() {
      return PageDetailModeEnum
    }
  },
  components: {CbFormTextWithImage}
}
